// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/BatchJobRun.yaml
// Generated: 2026-03-16T14:33:37.712Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { BatchJobRun } from '@/types/core/BatchJobRun';

/**
 * BatchJobRun Service (Read-Only)
 * Query operations for BatchJobRun via the ABP API.
 */
export const batchJobRunService = new ReadOnlyEntityService<BatchJobRun>(
  '/api/core/batchjobrun',
  'BatchJobRun',
);
